import React from 'react';
import { AppContent, SecondaryButton, Link } from '@common/components';
import { useSetBreadcrumbs } from 'works/legacy/lib/client-store';
import { Colors } from '@common/tokens';
import {
  IncentiveRatesList,
  IncentiveRatesListConfig,
} from '@scheduling/components';
import { ORGANIZATION_ADMIN_MENU } from 'works/legacy/pages/organization/admin-settings/organization-admin-vertical-nav-menu';
import { RATES_URLS } from '@institutions/services';
import { useCurrentMembership } from '@identity/hooks';

export function AdminIncentiveRatesPage() {
  const currentMembership = useCurrentMembership();

  useSetBreadcrumbs([
    {
      name: 'Admin',
      path: '/works/admin',
    },
    {
      name: 'Rates',
      path: '/works/admin/rates',
    },
    {
      name: ORGANIZATION_ADMIN_MENU.RATES__INCENTIVES.LABEL,
      path: ORGANIZATION_ADMIN_MENU.RATES__INCENTIVES.ROUTE,
    },
  ]);

  const config: IncentiveRatesListConfig = {
    showWorkforceGroupColumn: true,
    headerRightSlot: currentMembership.canCreateWorkforceGroupUnitRate ? (
      <Link to={`${RATES_URLS.INCENTIVES}/update`}>
        <SecondaryButton>Update Rates</SecondaryButton>
      </Link>
    ) : undefined,
  };

  return (
    <>
      <AppContent className="incentives-rates-page">
        <IncentiveRatesList config={config} />
      </AppContent>
      <style jsx>{`
        :global(.incentives-rates-page) {
          padding-right: 20px;
          padding-left: 20px;
          background-color: ${Colors.steelLighter};
        }

        :global(
          .incentives-rates-page .FilteredTable div.table-filter-controls
        ) {
          margin: 0;
        }
      `}</style>
    </>
  );
}
